module.exports = __webpack_public_path__ + "img/tianyaCenter.b09c0a44.png";